
import React from 'react';
import { HotelForm } from './HotelForm';

interface HotelEditFormProps {
  editingHotelId: string;
  onEditComplete: () => void;
  tripId: string;
}

export const HotelEditForm: React.FC<HotelEditFormProps> = ({ 
  editingHotelId, 
  onEditComplete, 
  tripId 
}) => {
  return (
    <div id="hotel-edit-form">
      <HotelForm 
        editHotelId={editingHotelId} 
        onEditComplete={onEditComplete}
        tripId={tripId} 
      />
    </div>
  );
};
